angular.module('lsnBase.detectorUserActvie', ['lsnBase']).run(['bodyInjectorHelper',
  function(bodyInjectorHelper) {
    bodyInjectorHelper.injectDirective('detectorUserActvie', 'detector-user-active');
  }
]);